// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"11b36518","400":"ad25ce33","406":"edab9b66","783":"ff232649","960":"ec40ba7e"}[chunkId] + ".chunk.js";
};